import "core-js/modules/es.object.assign";
import React from 'react';
import PopoverBase from 'rc-tooltip';
import classnames from 'classnames';
import { useTheme } from "../../../theme";
import './Popover.scss';
var CLASS_PREFIX = 'xyz-popover';
export var PLACEMENT = {
  left: 'left',
  right: 'right',
  top: 'top',
  bottom: 'bottom',
  topLeft: 'topLeft',
  topRight: 'topRight',
  bottomLeft: 'bottomLeft',
  bottomRight: 'bottomRight'
};

var Popover = function Popover(_ref) {
  var children = _ref.children,
      content = _ref.content,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? ['click', 'focus'] : _ref$trigger,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? PLACEMENT.right : _ref$placement,
      onVisibleChange = _ref.onVisibleChange,
      visible = _ref.visible,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'background' : _ref$color,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 15 : _ref$padding,
      _ref$overlayStyle = _ref.overlayStyle,
      overlayStyle = _ref$overlayStyle === void 0 ? {} : _ref$overlayStyle;

  var _useTheme = useTheme(),
      currentTheme = _useTheme.currentTheme;

  var visibleProps = {};

  if (typeof visible === 'boolean') {
    visibleProps.visible = visible;
  }

  if (typeof onVisibleChange === 'function') {
    visibleProps.onVisibleChange = onVisibleChange;
  }

  if (content) {
    return /*#__PURE__*/React.createElement(PopoverBase, Object.assign({
      placement: placement,
      trigger: trigger,
      overlay: content,
      prefixCls: CLASS_PREFIX,
      destroyTooltipOnHide: true,
      overlayClassName: classnames("theme-".concat(currentTheme), "".concat(CLASS_PREFIX, "-").concat(color)),
      overlayInnerStyle: {
        padding: padding
      },
      overlayStyle: overlayStyle
    }, visibleProps), children);
  }

  return children;
};

export default Popover;